var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableBlackViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 5,
    fill: "#272A3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.5C21 14.5 18.5625 10.0312 14.5 10.0312C10.4375 10.0312 8 14.5 8 14.5C8 14.5 10.4375 18.9688 14.5 18.9688C18.5625 18.9688 21 14.5 21 14.5ZM8.95282 14.5C8.99907 14.4295 9.05181 14.3511 9.11091 14.2663C9.383 13.8759 9.7845 13.3567 10.3011 12.8401C11.3483 11.7929 12.778 10.8438 14.5 10.8438C16.222 10.8438 17.6517 11.7929 18.6989 12.8401C19.2155 13.3567 19.617 13.8759 19.8891 14.2663C19.9482 14.3511 20.0009 14.4295 20.0472 14.5C20.0009 14.5705 19.9482 14.6489 19.8891 14.7337C19.617 15.1241 19.2155 15.6433 18.6989 16.1599C17.6517 17.2071 16.222 18.1562 14.5 18.1562C12.778 18.1562 11.3483 17.2071 10.3011 16.1599C9.7845 15.6433 9.383 15.1241 9.11091 14.7337C9.05181 14.6489 8.99907 14.5705 8.95282 14.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.4688C13.3782 12.4688 12.4688 13.3782 12.4688 14.5C12.4688 15.6218 13.3782 16.5312 14.5 16.5312C15.6218 16.5312 16.5312 15.6218 16.5312 14.5C16.5312 13.3782 15.6218 12.4688 14.5 12.4688ZM11.6562 14.5C11.6562 12.9294 12.9294 11.6562 14.5 11.6562C16.0706 11.6562 17.3438 12.9294 17.3438 14.5C17.3438 16.0706 16.0706 17.3438 14.5 17.3438C12.9294 17.3438 11.6562 16.0706 11.6562 14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableBlackViewIcon);
export default __webpack_public_path__ + "static/media/table-black-view-icon.421b233080e004aff83f5d03a35bf51b.svg";
export { ForwardRef as ReactComponent };